import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import { Button, Space, Table } from "antd";
import Column from "antd/es/table/Column";
import { API_LIST_EMAIL_TEMPLATE } from "api/email";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

function EmailTemplateTable() {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  
  const { t } = useTranslation();
  const navigate = useNavigate();
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const payload = {};
      const res = await API_LIST_EMAIL_TEMPLATE(payload);

      console.log(res?.data, "email template");
      setData(res?.data);
      setIsLoading(false);
    } catch (err) {
      console.log(err, "error fetch email");
      setIsLoading(false);
    }
  };
  const handleEdit = (record) => {
    // setSelectedStore(record);
    // setEditModalVisible(true);
    navigate(`/admin/email/update-email-template/${record._id}`, {
      state: { data: record },
    });
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
    <div className="flex w-full flex-grow justify-end sm:w-auto mb-5">
          <Link
            to={"/admin/email/create-email-template"}
            className="linear p-[4px 11px] flex w-full max-w-[9rem] cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-2 text-center text-base font-medium text-white transition duration-200 hover:bg-white hover:text-brand-500 dark:bg-brand-400 dark:text-white  dark:active:bg-brand-200"
          >
            + {t("Create Template")}
          </Link>
        </div>
      <Table dataSource={data} loading={isLoading}>

        <Column
          title={t("Template Name")}
          dataIndex="template_name"
          key="template_name"
          width="9rem"
        />
        <Column
          title={t("Description")}
          dataIndex="description"
          key = 'description'          
          width="9rem"
        />

        <Column
          title={t("Actions")}
          key="actions"
          width={"9rem"}
          render={(text, record) => (
            <Space>
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              />
              {/* <Button
                type="default"
                icon={<EyeOutlined />}
                // onClick={() => handleView(record)}
              /> */}
              {/* <Button
                onClick={() => {
                  setSelectedOrder(record);
                  console.log("record", record);
                  setTimeout(() => {
                    handlePrint();
                  }, 100);
                }}
              >
                Print
              </Button> */}
            </Space>
          )}
        />
      </Table>
    </div>
  );
}
export default EmailTemplateTable;
